/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

class Tools {
    /**
     * Get current page language
     * @return string
     */
    static getCurrentPageLang() {
        let lang = document.querySelector("html").getAttribute("lang");

        if (lang) {
            return lang;
        } else {
            throw new Error("Brak atrybutu lang w tagu html!");
        }
    }

    /**
     * Detect mobile browser
     * @return boolean
     */
    static detectMobileBrowser() {
        const a = navigator.userAgent || navigator.vendor || window.opera;

        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        ) {
            return true;
        }
    }

    /**
     * Match media
     * @param {string} mediaQueryString
     * @return boolean
     */
    static matchMedia(mediaQueryString) {
        return window.matchMedia(mediaQueryString).matches;
    }

    /**
     * Cookie set
     * @param {string} cname
     * @param {number|string} cvalue
     * @param {number} exdays
     */
    static cookieSet(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    /**
     * Cookie get
     * @param {string} cname
     */
    static cookieGet(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(";");

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];

            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }

            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }

        return "";
    }

    /**
     * Cookie check
     * @param {string} cname
     */
    static cookieCheck(cname) {
        let cookieName = this.cookieGet(cname);

        return cookieName !== "";
    }

    /**
     * Cookie value
     * @param {string} cname
     */
    static cookieValue(cname) {
        return this.cookieGet(cname);
    }

    /**
     * Body backdrop
     */
    static bodyBackdrop(type = "") {
        if (type === "") {
            throw new Error("Funkcja wymaga parametru: show, hide, toggle.");
        }

        let body = document.querySelector("body");

        if (type === "show") {
            body.classList.add("body-backdrop--active");
        } else if (type === "hide") {
            body.classList.remove("body-backdrop--active");
        } else if (type === "toggle") {
            body.classList.toggle("body-backdrop--active");
        }
    }

    /**
     * Copy to clipboard
     * @param inputId
     */
    static copyToClipboard(inputId = null) {
        if (!inputId) {
            throw new Error("Wymagane ID pola input z którego będzie kopiowana zawartość do schowka.");
        }

        document.getElementById(inputId).select();
        document.execCommand("copy");
    }

    /**
     * Parse string values in object literal
     * @param objectLiteral
     * @returns {{}}
     */
    static parseStringValuesInObjectLiteral(objectLiteral = {}) {
        for (const key in objectLiteral) {
            if (Object.hasOwnProperty.call(objectLiteral, key)) {
                const value = objectLiteral[key];

                if (
                    (value !== "" && typeof value === "string" && value === "false") ||
                    (value !== "" && typeof value === "string" && value === "true") ||
                    (value !== "" && typeof value === "string" && !isNaN(value))
                ) {
                    objectLiteral[key] = JSON.parse(value);
                }
            }
        }

        return objectLiteral;
    }

    /**
     * Scroll to
     * @param scrollableElement
     * @param scrollTop
     */
    static scrollTo(scrollableElement = document.querySelector("body"), scrollTop = 0) {
        // @todo do przepisania na JS
        jQuery(scrollableElement).animate(
            {
                scrollTop: scrollTop,
            },
            300,
            function () {
                jQuery(this).clearQueue();
            }
        );
    }

    /**
     * Load Third-Party scripts
     * @param html
     */
    static loadScriptsDynamically(html = "") {
        let body = document.querySelector("body") || document.documentElement;
        let head = document.querySelector("head") || document.documentElement;
        const parser = new DOMParser();
        const documentScriptsSrc = [].slice.call(document.scripts).map(function (script, index) {
            return script.src;
        });
        const scripts = [].slice.call(parser.parseFromString(html, "text/html").scripts);

        if (scripts.length > 0) {
            let scriptElement = null;

            scripts.forEach(function (script, index) {
                if (Boolean(script.src)) {
                    if (!documentScriptsSrc.includes(script.src)) {
                        scriptElement = document.createElement("script");
                        scriptElement.setAttribute("src", script.src);
                        body.appendChild(scriptElement);
                    }
                }
            });

            if (Boolean(scriptElement)) {
                scriptElement.addEventListener("load", function (event) {
                    scripts.forEach(function (script, index) {
                        if (Boolean(script.text)) {
                            let scriptElement = document.createElement("script");

                            scriptElement.text = script.text;
                            head.insertBefore(scriptElement, head.firstChild);
                            head.removeChild(scriptElement);
                        }
                    });
                });
            } else {
                scripts.forEach(function (script, index) {
                    if (Boolean(script.text)) {
                        let scriptElement = document.createElement("script");

                        scriptElement.text = script.text;
                        head.insertBefore(scriptElement, head.firstChild);
                        head.removeChild(scriptElement);
                    }
                });
            }
        }
    }

    /**
     * Wykonanie zdarzenia submit na każdym formularzu nie będącym dzieckiem elementu #dialog.
     * @param form
     */
    static submit(form) {
        if (!Boolean(form)) {
            throw new Error("Funkcja wymaga przekazania jako parametru elemntu DOM formularza!");
        }

        if (!Boolean(form.closest("#dialog"))) {
            form.submit();
        }
    }

    /**
     * Usunięcie wiodącego zera
     * @param value
     * @returns {number}
     */
    static removeLeadingZeros(value) {
        if (!value) {
            throw new Error("Wymagany parametr funkcji!");
        }

        if (isNaN(value)) {
            throw new Error("Wymagany parametr musi zawierać cyfry!");
        }

        let result;

        if (value.match(/^0[1-9]+|^0+/)) {
            result = parseInt(value);
        } else {
            result = parseInt(value);
        }

        return result;
    }

    /**
     * Generowanie atrybutu style="".
     * @param {Object} style - obiekt ze stylami.
     */
    static getStyleAttribute(style = {}) {
        if (Object.keys(style).length > 0) {
            const properties = [];

            for (const key in style) {
                if (Object.hasOwnProperty.call(style, key)) {
                    const value = style[key];

                    if (Array.isArray(value)) {
                        value.forEach((v, index) => {
                            properties.push(key + ": " + v);
                        });
                    } else {
                        properties.push(key + ": " + value);
                    }
                }
            }

            return `style="${properties.join("; ")}"`;
        } else {
            return "";
        }
    }

    /**
     * Pobranie ilości minut ze string'a czasu.
     * @param timeString
     * @return {number}
     */
    static getHoursFromTimeString(timeString = "00:00:00") {
        return Date.parse(`Thu, 01 Jan 1970 ${timeString} GMT`) / 1000 / 60 / 60;
    }

    /**
     * Pobranie ilości minut ze string'a czasu.
     * @param timeString
     * @return {number}
     */
    static getMinutesFromTimeString(timeString = "00:00:00") {
        return Date.parse(`Thu, 01 Jan 1970 ${timeString} GMT`) / 1000 / 60;
    }

    /**
     * Pobranie ilości sekund ze string'a czasu.
     * @param timeString
     * @return {number}
     */
    static getSecondsFromTimeString(timeString = "00:00:00") {
        return Date.parse(`Thu, 01 Jan 1970 ${timeString} GMT`) / 1000;
    }

    /**
     * Pobranie różnicy pomiędzy dwoma datami.
     * @param str1
     * @param str2
     * @returns {number|{s: number, d: number, ms: number, h: number, diff: number, m: number}}
     */
    static dateDiff(str1, str2) {
        let diff = Date.parse(str2) - Date.parse(str1);

        return isNaN(diff)
            ? NaN
            : {
                  diff: diff,
                  ms: Math.floor(diff % 1000),
                  s: Math.floor((diff / 1000) % 60),
                  m: Math.floor((diff / 60000) % 60),
                  h: Math.floor((diff / 3600000) % 24),
                  d: Math.floor(diff / 86400000),
              };
    }

    /**
     * Ustawia wartości (string) klucza w obiekcie Map.
     * @param map
     * @param key
     * @param value
     * @returns {Map<any, any>}
     */
    static mapSetStringDuplicateKeys(map = new Map(), key, value = "") {
        let newValue = map.get(key) + value;

        if (map.has(key)) {
            map.set(key, newValue);
        } else {
            map.set(key, value);
        }

        return map;
    }

    /**
     * Dodawanie reguł arkusza stylów do dokumentu.
     * @param id
     * @param rules
     */
    static addStylesheetRules(id, rules) {
        let rulesLength = rules.length;

        if (rulesLength > 0) {
            const styleEl = document.createElement("style");
            styleEl.id = id;

            // Dołączenie elementu <style> do <head>
            document.head.appendChild(styleEl);

            const styleSheet = document.getElementById(id).sheet;

            for (let i = 0; i < rulesLength; i++) {
                const rule = rules[i];

                // Wstaw regułę CSS
                styleSheet.insertRule(rule, i);
            }
        }
    }

    /**
     * Dodanie znaku ucieczki dla znaków specjalnych występujących w wyrażeniach regularnych.
     * @param string
     * @return {any}
     */
    static escapeRegExpSpecialCharacters(string = "") {
        return string.replace(/(\[)|(])|({)|(})|(\()|(\))|(\\)|(\^)|(\$)|(\.)|(\|)|(\?)|(\*)|(\+)/gi, (match) => {
            return "\\" + match;
        });
    }

    /**
     * Pobieranie losowego koloru.
     * @returns {string}
     */
    static getRandomColor(excludedColors = []) {
        let randomColor = "#" + ("00000" + ((Math.random() * (1 << 24)) | 0).toString(16)).slice(-6);

        if (excludedColors.includes(randomColor)) {
            this.getRandomColor(excludedColors);
        }

        return randomColor;
    }

    /**
     * formatSizeUnits
     * @param $bytes
     * @returns {*}
     */
    static formatSizeUnits($bytes) {
        if ($bytes >= 1073741824) {
            $bytes = ($bytes / 1073741824).toFixed(2) + " GB";
        } else {
            if ($bytes >= 1048576) {
                $bytes = ($bytes / 1048576).toFixed(2) + " MB";
            } else {
                if ($bytes >= 1024) {
                    $bytes = ($bytes / 1024).toFixed(2) + " KB";
                } else {
                    if ($bytes > 1) {
                        $bytes = $bytes + " bajtów";
                    } else {
                        if ($bytes === 1) {
                            $bytes = $bytes + " bajt";
                        } else {
                            $bytes = "0 bajtów";
                        }
                    }
                }
            }
        }

        return $bytes;
    }

    /**
     * Pobranie właściwej formy wyrazu.
     * @param word
     * @param number
     */
    // @todo
    static getWordForm(word, number) {}
}

export { Tools };
